// extracted by mini-css-extract-plugin
module.exports = {"labelStyle":"index_labelStyle_B0YDy","selectBox":"index_selectBox_2kEjP","mandatory":"index_mandatory_23vlM"};